var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMappaGenerale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 536.15 488.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "testi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400,66.89c-.4.67-.83,1.39-1.28,2.15",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.35,78.32c-1.45,2.52-2.91,5.07-4.27,7.43",
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 3.22 10.72",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "387.52 90.87 375 132.89 370.58 142.77",
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 0 0 5.36 10.72 3.22 10.72",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "368.4 147.67 367.38 149.95 369.13 151.73",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 376.17,
    y1: 158.92,
    x2: 381.81,
    y2: 164.67,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 3.02 10.06",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.87,167.57l14.13,8.3s15,7.01,15,15.01,5,26,5,26c0,0-1,7,17,10s57,4,57,4l35,20s7.26,12.72,6,26c-1.72,18.03-6.38,121.54-7.67,150.48",
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 0 0 5.03 10.06 3.02 10.06",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.11,432.39c-.07,1.62-.11,2.49-.11,2.49h-2.5",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 515.14,
    y1: 434.94,
    x2: 507.65,
    y2: 434.98,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 2.81 9.36",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 502.97,
    y1: 435,
    x2: 324.18,
    y2: 435.85,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 0 0 4.68 9.36 2.81 9.36",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 319.5,
    y1: 435.87,
    x2: 317,
    y2: 435.89,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.89,
    y1: 439.01,
    x2: 240.62,
    y2: 436.53,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.47,
    y1: 435.16,
    x2: 240.35,
    y2: 434.06,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 .41 1.38",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "240.27 433.37 240 430.89 237.5 431.01",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.79,
    y1: 431.5,
    x2: 220.01,
    y2: 431.89,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 2.92 9.73",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "215.15 432.13 140 435.89 94 438.89 58.94 426.36",
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 0 0 4.86 9.73 2.92 9.73",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "54.35 424.73 52 423.89 53.03 421.61",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.09,
    y1: 412.62,
    x2: 60.33,
    y2: 405.43,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 2.96 9.86",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "62.36 400.94 66 392.89 41 313.89 7.09 290.15",
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 0 0 4.93 9.86 2.96 9.86",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3.05 287.32 1 285.89 2.5 283.88",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.67,
    y1: 275.62,
    x2: 13.61,
    y2: 269.02,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 3.09 10.31",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.7,
    y1: 264.89,
    x2: 151.89,
    y2: 84.02,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 0 0 5.16 10.31 3.09 10.31",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "154.98 79.89 156.48 77.89 155.61 75.54",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.7,
    y1: 70.38,
    x2: 152.17,
    y2: 66.25,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 1.65 5.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.22,
    y1: 63.68,
    x2: 146.82,
    y2: 51.81,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 0 0 2.75 5.5 1.65 5.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "145.87 49.23 145 46.89 146.81 45.16",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.61,
    y1: 41.52,
    x2: 153.65,
    y2: 38.61,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 1.58 5.26",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.55,
    y1: 36.79,
    x2: 164.29,
    y2: 28.43,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 0 0 2.63 5.26 1.58 5.26",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "166.19 26.61 168 24.89 170.09 26.26",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.13,
    y1: 30.23,
    x2: 180.97,
    y2: 33.41,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 2.17 7.23",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 183.99,
    y1: 35.39,
    x2: 197.89,
    y2: 44.53,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 0 0 3.62 7.23 2.17 7.23",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "200.91 46.51 203 47.89 205.26 46.82",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "215.25 42.12 220 39.89 223.41 40.96",
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 3.31 11.03",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.67,
    y1: 42.61,
    x2: 282.35,
    y2: 59.48,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 0 0 5.52 11.03 3.31 11.03",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "287.61 61.14 290 61.89 292.01 60.41",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.09,
    y1: 53.73,
    x2: 308.36,
    y2: 48.39,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 3.38 11.27",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.9,
    y1: 45.05,
    x2: 333.78,
    y2: 29.7,
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 0 0 5.63 11.27 3.38 11.27",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.32,26.37l2.01-1.48c.69.47,1.37.94,2.06,1.42",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.2,31c1.81,1.25,3.62,2.51,5.43,3.77",
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 2.48 8.27",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.02,37.14c5.18,3.61,10.37,7.25,15.56,10.92",
    style: {
      fill: "none",
      stroke: "#666",
      strokeDasharray: "0 0 0 0 4.13 8.27 2.48 8.27",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.96,50.44c.68.48,1.36.96,2.04,1.44",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m336.8,159.87c.97,4.38-5.57,8.15-12.92,15.89-4.46,4.69-10.23,11.92-15.27,22.62-4.45-2.15-7.76-4.32-10-5.95-2.19-1.59-2.97-2.39-3.5-3.55-1.2-2.64.26-4.23-1-7-1.09-2.41-2.74-2.41-3-4-.44-2.66,3.8-4.69,6-7,7.78-8.18-3.96-26.17,1-30,3.04-2.35,8.01,3.99,27,12,7.39,3.12,11.02,4,11.68,6.99Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.12,153.88s-38-25-41-28c.56-1.77,6-5,6-5l32-28s-7-6,0-10-7.49-.62-14-2c-7.95-1.69-12-13-17-16s21.44-10.23,23-19c.14-.77.48-3.58,2-7,.53-1.19,1.39-3.09,3-5l7-5,37,26s-.56,7.18-4,26c-4.07,22.29-5,27-7,33s-21-23-21-23l-6,4s15,20,20,26c.11,2.49-.93,4.99-3,10-3.44,8.31-8.28,13.91-11,17-3.11,3.54-6,6-6,6Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.12,164.88s14,3,15,6c.88,2.63.2,5.26,0,6-.2.72-.81,6.55-4,6-1.33-.23-14.85-5.02-15-7-.22-2.82,3-9,4-11Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.12,108.88c-7.09,2.86-7.91,11.61-17,21-.67.7-2.15,2.18-2,4,.22,2.71,3.78,3.05,7,7,.33.4,4.71,5.9,3,10-.9,2.17-2.84,2.34-3,4-.25,2.59,4.17,5.02,6,6,14.21,7.62,21.31,11.42,24,11,11.81-1.86,22.21-21.36,18-38-4.52-17.87-25.11-29.4-36-25Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.12,187.88c-3.48,1.05-7.62-.71-9-4-1.41-3.37.77-6.67,1-7,.35-.51,1.63-2.32,4-3,3.19-.92,7.49.46,9,4,1.71,4-.98,8.79-5,10Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.12,275.88c3,0,19-25,19-25-.64-1.62-2.22-4.06-4-4-4.26.13-9,15-12,17-2.57,1.71-4.37-.62-8,1-3.11,1.39-6.54,4.55-6,7,.62,2.83,6.44,4,11,4Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.12,399.88c1.77,4.59,6.86,6.75,11,6,.8-.14,4.25-.88,6-4,1.79-3.18.53-6.56,0-8-.5-1.34-1.69-4.54-5-6-3.23-1.42-7.33-.68-10,2-2.79,2.79-3.21,6.86-2,10Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.12,286.88c-4.2.28-7.1-4-7-7,.04-1.2.56-2.19,1-3,.47-.87,1.81-3.39,4-4,2.96-.82,7.41,1.87,8,6,.52,3.64-2.06,7.74-6,8Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.12,273.88c-3-1-8.3-6.14-8-10,.15-1.95,1.13-3.56,2-5,1.13-1.85,3.19-2.61,5-3,1.82-.39,2.45-.19,4,1,2.69,2.05,6.31,6.81,6,11-.3,4.08-4.46,7.51-9,6Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.12,293.88c.59-3.76,2.9-3.15,13-18,2.07-3.04,3.35-5.09,6-6,2.65-.91,4.04.22,13,1,4.09.36,5.07.23,6,0,3.57-.9,4.55-2.98,7-3,2.75-.02,4.84,2.56,6,4,15.3,18.94,15.77,19.02,16,21,1.44,12.38-14.55,28.24-32,29-19.37.84-36.72-17.11-35-28Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.62,189.38c.17-6.25.3-8.82,4-14,2.5-3.5,53-70,53.5-69.5,1,1,48.96,15.23,56.5,35.5,0,0,10.53,34.15-14.5,72.5-5.09,7.8-17,14-17,14-3.62,3.77-.97,3.24-4.5,5.5-10.03,6.42-21.78,4.75-27,4-24.69-3.53-51.61-25.48-51-48Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.62,94.38c-5.5-.5,5.78-9.17,6.5-14.5.25-1.83-1.68-2.41-2.5-6.5-.5-2.5-13.5-17.5-8-27,1.03-1.78,2.75-3.97,7-8,5.29-5.01,11.55-10.66,13-10,5.5,2.5-1.87,4.71-.5,8.5,0,0,4,3,4.5,3.5s3.05-4.75,5.5-5.5c0,0,13.67,14.98,24,15,1.45,0,1.13,1.5,5.5-.5,8.38-3.84,9.99-3.99,13-7,.5-.5,20.5,8.5,20.5,8.5,1.77,5.01-5.94,9.7-6.5,10.5-2.85,4.08-6.37,5.35-6,8,.23,1.62,1.81,3.14,3,3,1.4-.17,1.04-2.82,3-4,2.5-1.5,13.5,3.5,13.5,3.5,1.12,2.42-1.01,4.1.5,5.5,1.18,1.09,3.66,1.13,5,0,2.62-2.21-3.45-10.6,1-11,5.5-.5,10.37-3.26,17-4,4.5-.5,12.02.09,16,4,.33.33,4.07,4.08,3,7-.96,2.63-4.84,1.94-6,4-2.53,4.51,12.57,15.51,13.5,25.5,1.06,11.36-16.27,23.13-31.5,25.5-35.24,5.49-67.72-64.22-71-62-2.11,1.43,12.17,28.38,11,29-.34.18,4.07,1.42,2.5,1.5-2.34.12-4,1-8,5-3.21,3.21-6.9,10.4-12.5,16.5,0,0-7.01-2.09-5-5,4.5-6.5,6.5-9.5,6.5-9.5l6-7c1,1-7.5-4.5-7.5-4.5l-12.5,16.5-12.83,8.5-10.67-23Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.12,187.88c-1-1,0-9.5,0-9.5,0,0-2-7.43-4.5-7.96-2.5-.54-6.5-.54-8.5,2.46s-10.5,23.02-10.5,23.02l-22.48,27.08-17.19,16.78-5.83,10.12,45.5,31.35s7.72-.65,10.11,0,13.39,3.35,13.39,0v-93.35Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.62,198.38s5.17-.5,5.33,3-28.83,64.9-35.83,66.2-66.09-44.6-66.09-44.6c0,0-8.15-3.49-3.91-14.1,4-10,6-13,6-13l10,6,9,2,3-7-18-8-2.05-.78s.02-7.22,2.53-6.72,11.01,5.04,11.01,5.04l14.65,6.01,7.35,3.47,27.07-60.44,24,11.61-8.07,15.81-4.5,12.87-2.62,5.33-4.38,8.8,8,5s5-11,8-10,4,8,4,8l5.5,5.5Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.12,308.88h34.5v13.5l-20.25-3.22v6.09l18.75,2.63.02,5-6.52,2.87s-10,8.72-12.25,5.93-4.25-5.8-4.25-5.8l-8.09,3-10.91-19,9-11Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.88,150.88l-5.76,11,1.31,1s4.2-4.04,4.44-4.02,20.15,11.28,20.15,11.28v4.72h6.81v1.48l5.93,2.04-1.78,20,3.56,21.5,20.07-2.5-4.37-9-2.37-10-1.76-11.5s-1.36-1.41-5.18-5.2-41.06-30.8-41.06-30.8Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.12,277.88l12,10,4.65,5.79s-4.35,7.95-2,10.08c2.35,2.13,9.09,1.98,8.72,3.56s-1.61,5.97-1.61,5.97l26.24,4.6,12.28-21.5-14.28-9.5-15.86-18.09-7.14,4.09,11,22-5,4-13.46-23-15.54,2Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.57,274.71s1.63,8.16,4.09,8.16c2.46,0,6.81-4.08,6.81-4.08,0,0,.19-3.09,5.42,0,5.23,3.09,8.21,14.88,8.21,14.88l3.07,3.63,5.95,3.57s-2,1.15,0,2.57l2,1.43,16,4s7,4,8,3-.5-50.5-.5-50.5l-17.5-16.5-27-9-11,13-3.56,25.83Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.12,363.88s12-4,14-2,12.28,55.5,12.28,55.5c0,0,2.28,7.5,0,10.5-2.28,3-23.39,1.65-23.39,1.65l-40.11-17.69,37.22-47.96Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m438.54,361.28l-16.5,24.51-10.31-1.14,3.54-45.25s4.73,0,5.73.99c.99.99,13.92,9.95,13.92,9.95l3.63,10.94Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10,
      strokeWidth: ".99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.37,362.59l-13.55,21.06s-5.4,3.33,3.83,3.9,19.74,1.98,19.74,1.98c0,0,3.41-2.11,3.9-3.75s10.44-16.56,10.44-16.56c0,0,.99-9.95,0-11.93-.99-1.99-5.97-6.96-5.97-6.96l-18.4,12.26Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10,
      strokeWidth: ".99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.79,403.05s-2.98.48,0-8.71c2.98-9.19,11.93-20.13,13.92-23.11,1.99-2.98,5.78-8.95,9.85-8.95s8.55-11.93,8.55-11.93l27.7-16.91,12.08,1.49-4.48,97.96h-47.39l-20.24-29.84Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10,
      strokeWidth: ".99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.62,354.12s24.5,1.76,27.5-3.24,5-44,8.24-54.5c3.24-10.5,6.76-13.17,2.76-16.33-4-3.17-56.09-41.67-56.09-41.67l-12.44-11.5s-3.57-3-6.52,0c-2.94,3-9.44,11.88-9.44,11.88,0,0-4.87,4.12-4.19,7.62.69,3.5,9.19,9.37,9.19,9.37,0,0,4.02,3.13,3.26,5.63-.76,2.5-8.76,1.9-8.26,6.2s12.44,10.69,12.44,10.69l-58.7,46.82,21.76,16.79,11.43-3,7.7-13.79,5.37-5.34s3.01-8.35,5.76-7.11c2.74,1.24,6.69,5.33,6.69,5.33,0,0-10.05,16.17-3,13.04,7.06-3.13,5.32-1.87,9.69,0,4.37,1.87,8.68,7.87,8.68,7.87l2.69,12s-.26,4,.87,6,14.63-2.76,14.63-2.76Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.24,331.57h-15.84s-5.54-.13-5.05,3.35,4.48,41.71,4.48,44.97,2.98,1.27,2.98,1.27c0,0,21.88,2.98,26.85,2.49s8.95-6.46,8.95-6.46l2.35-.24,4.12-4.24-9.61-22.28-4.42-8.55-1.38-9.43-13.43-.88Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10,
      strokeWidth: ".99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.62,325.08h-10.52s-6.98-.39-5.98-8.3c1-7.91,19.83-49.21,19.83-49.21,0,0,4.91-13.7,13.04-6.2s27.13,20.5,27.13,20.5c0,0,11,6.93,15.5,6.46s8.5,3.54,7,8.04-2.5,14.57-3,18.04-6,9.46-8.25,7.96-24.53,2.91-29.89,2.7-7.31,0-7.31,0h-17.56Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.96 334.38 306.12 343.88 309.48 355.01 332.62 356.88 324.7 334.38 303.96 334.38",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.4,385.79c4.4.35,35.07,2.36,35.07,2.36,0,0,4.86.31,5.5,4.13.64,3.81,16.31,0,16.31,0l5.21,2.82,6.96-1.99s1.73,0,2.85,1.99,6.59,12.21,6.59,12.21c0,0,1.12,1.63-2.17,4.66-3.3,3.02-31.64,13.61-31.64,13.61,0,0-6.46,2.34-12.43,2.34s-18.9-5.97-26.85-19.89c-7.96-13.92-9.8-22.58-5.4-22.23Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10,
      strokeWidth: ".99px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.49 379.18 342.42 388.13 353.36 408.02 359.33 404.04 348.39 384.15 354.36 381.17 365.3 400.06 371.06 396.72 360.45 379.18 360.33 363.26 337.45 361.28 330.49 379.18",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10,
      strokeWidth: ".99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.25,367.24v6.76l-6.96,5.01,7.9,17.71s12.98-7.6,16.96-9.59c3.98-1.99,11.64,0,14.27-2.49,2.63-2.49,2.63-46.3,2.63-46.3,0,0-23.87-3.92-24.86.06-.99,3.98-1.05,20.39-1.05,20.39l-8.9,8.45Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10,
      strokeWidth: ".99px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.81 358.79 371.06 354.55 371.06 346.11 375.48 339.4 375.48 312.71 355.35 344.37 349.39 340.39 378.23 294.64 356.33 292.89 352.37 327.46 334.47 336.41 337.45 353.32 362.81 358.79",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10,
      strokeWidth: ".99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.12,331.01s-8-.13-7-4.13,2-26,2-26c0,0,2-7.41,5-7.2s42.44.2,44.72,2.7c2.28,2.5,0,18.63,0,18.63l-9.48,7.37-.57,5.38s1.33,4.12-4.67,5.12l-30-1.87Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.62,338.88s.8-4,4.15-6,2.67,0,2.67,0l1.94,1.5s3.48-1.5,9.61-1.5,7.91,8.5,7.91,8.5l2.76,17s-9.5,1.31-14.52,6.41-11.52,15.41-11.52,15.41l-18.5-16.31,15.5-25Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.96,385.53l-5.83,8.35s-3.85,5-5.43,0c-1.57-5-1.57-4.58-1.57-4.58v-9.11s-2-3.31-7-2.31-9.8,2.31-9.8,2.31l-7.82-3.85s-2.39-1.46,5.61-4.46,13.11,0,13.11,0l18.72,13.65Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.44,367.17c-1.31.71-3.31-.29-9.31,1.71s-8,5-8,5l-9.06-3.35s5.06-15.98,5.56-15.81,20.81,12.46,20.81,12.46Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.88,393.88c6.24,1,10.69-.72,10.96,2.64.28,3.36-2.83,5.03-1.78,6.19,1.06,1.17,20.02,9.09,21.04,9.13s4.24-2.96,9.13-3.96-6.61,6.39-6.61,6.39c0,0-32.98-12.5-32.74-12.44s-3.26,6.06-3.26,6.06c6.39,2.56,3.62,1.45,27.5,11,0,0,1.26-2.81-1.87,3.09-3.13,5.91-7.13,4.91-15.13,9.41s-8,5.5-13,5.5-13.8-2.5-13.8-2.5c-7.2-2.41-12.15-3.03-23.2-8.5,0,0,13.19-40,16.09-43,2.91-3,13.91,5,13.91,5,0,0,6.52,5,12.76,6Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.12,427.88l-6.5-4.72,11.5-27.3v-8.25l-23.61-74.33-38.39-27.4,55.04-72.5,18.96,21.5s3-.11,0,6.94-23.5,32.3-23.5,32.3l48.5,30.76,14.94,29.5-18.07,29.92s-7.87-2.42-9.87-7.42c-1.53-3.83,2.61-13.02,5-19,4-10-1.23-6.1-1-7,0,0-5,16-10,15s-23-13-18-36c-3-3-4-3-8-5s-8-6-11-2-2,14,3,18,2.37,2.26,8.69,10.13c6.31,7.87,4.31,28.13,7.31,32s4,1.87,6,.87,6.26-1,7.13-5.5c.87-4.5-10.13-14.5-7.13-13.5s12,8,12,8c0,0,1.89,8,1.94,9,.06,1-24.94,66-24.94,66Z",
    style: {
      fill: "red",
      opacity: 0.48,
      stroke: "gray",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m154.17,87.85s19.46,12.19,20,13c2,3-1,9-1,9,0,0,35,25,40,31s1,13,1,13c0,0-18,48-20,53-1.89,4.73-2,6-2,6h-8l-16-11s-9.92-4.33-2-17c10-16,24.56-40,24.56-40h.44l-49-40,12-17Z",
    style: {
      fill: "#ccc",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.17,357.85c-9.59.02-25.9,1.54-30,2-18,2-18,3-29,16-12.33,14.57-18.92,22.13-29,34-4.9,5.77-10,8-18.74,14.74-1.59,2.77-1.96,6.08-.26,8.26.92,1.18,3.25,1.63,7,1,13-2.17,103-5,103-5l-3-71Z",
    style: {
      fill: "#ccc",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.17,275.85v12l73,5s7.58.08,9-7c1-5,1.23-8.11,1-8s25,1,25,1c13,2,14-5,14-5,1-3,1-12,1-12h8l1-21s14-12,47,20l-2,45h-9v28h15l3-54s3-21-10-30c-16.22-11.23-21-16-31-17-17.18-1.72-55-1-66-7-6.86-3.74-6-9-6-9h-10l-3,62-2,1-58-4Z",
    style: {
      fill: "#ccc",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.17 73.85 289.17 84.85 343.17 45.85 329.98 34.85 281.17 73.85",
    style: {
      fill: "#ccc",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.17,433.85s33.66-27.74,68-43c9-4,51-1,51-1,16.5.74,13,7,16,7h36v37h-171Z",
    style: {
      fill: "#ccc",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.17,218.85l31-41,73,53,14-7,5,5-42,33s-13,11-26,1c-11.78-9.06-55-44-55-44Z",
    style: {
      fill: "#ccc",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174,72.89l83,62-38,97,17.19,7.38,38.81-99.38,11,7-9,12,29,21,20-27-28-21-8,10-12-7c19.32-15,38.65-30.01,57.97-45.01,9.01-7,18.02-13.99,27.03-20.99l-12-15-81,64-84-61-12,16Z",
    style: {
      fill: "gray",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137 207.89 100 180.89 149.56 116.89 186 143.89 137 207.89",
    style: {
      fill: "gray",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264 229.89 279 237.89 297 210.89 281 200.89 264 229.89",
    style: {
      fill: "gray",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351 267.89 405 270.89 410 194.89 355.88 191.94 351 267.89",
    style: {
      fill: "gray",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403 306.89 402 326.89 458 327.89 451 339.89 440.81 333.1 425 356.89 450 373.89 466 349.89 456.61 342.98 464 330.89 488 382.89 505 374.89 479 321.89 512 271.89 496 260.89 463 309.89 403 306.89",
    style: {
      fill: "gray",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285 340.89 285 371.89 314 371.89 314 359.89 328 359.89 297 406.89 311 416.89 345 367.89 403 371.89 404 351.89 347 348.89 321 295.89 302 304.89 328 352.89 314 352.89 314 340.89 285 340.89",
    style: {
      fill: "gray",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507,
    y: 409.89,
    width: 16,
    height: 12,
    style: {
      fill: "gray",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42 248.89 124.85 311.41 207 245.89 220 261.89 134 326.89 147 335.89 155 324.89 183 344.89 162 372.89 135 351.89 142.62 341.03 131 331.89 93 430.89 74 423.89 113 326.89 30 264.89 42 248.89",
    style: {
      fill: "gray",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.57,1.63V0h1.61v1.63h-1.61Zm0,6.77V2.4h1.61v6h-1.61Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.27,8.4h-1.61V2.4h1.6v.34c.54-.32,1.04-.48,1.5-.48.8,0,1.35.24,1.66.71.3.47.46,1.2.46,2.18v3.25h-1.61v-3.2c0-.51-.06-.89-.18-1.13s-.36-.37-.72-.37c-.33,0-.64.06-.95.17l-.14.05v4.49Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.74,9.15c0,.68-.26,1.19-.79,1.52-.53.33-1.24.49-2.14.49s-1.59-.12-2.08-.36c-.48-.24-.73-.68-.73-1.31,0-.5.29-.98.86-1.43-.3-.2-.44-.5-.44-.91,0-.16.12-.42.36-.79l.11-.17c-.54-.39-.82-.97-.82-1.73s.23-1.32.69-1.66c.46-.34,1.07-.52,1.83-.52.34,0,.68.04,1.02.12l.19.04,1.93-.06v1.28l-.9-.07c.18.27.26.54.26.82,0,.8-.2,1.35-.61,1.66-.41.3-1.05.46-1.92.46-.18,0-.35-.02-.49-.05-.08.21-.12.38-.12.51s.07.22.2.27c.14.05.46.08.96.08,1.01,0,1.7.14,2.06.4.37.26.55.73.55,1.42Zm-4.15.17c0,.34.42.52,1.27.52s1.27-.2,1.27-.6c0-.22-.07-.35-.22-.41-.14-.06-.45-.09-.91-.1l-1.08-.08c-.22.22-.32.44-.32.68Zm.1-4.91c0,.59.31.88.92.88s.92-.29.92-.88-.31-.88-.92-.88-.92.29-.92.88Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.71,8.4V2.4h1.6v.64c.67-.4,1.31-.66,1.92-.78v1.62c-.65.14-1.2.28-1.67.42l-.24.08v4.02h-1.61Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.79,6.88c.19.16.46.25.81.25.74,0,1.41-.02,1.99-.07l.34-.04.02,1.19c-.92.22-1.75.34-2.5.34-.9,0-1.56-.24-1.97-.72-.41-.48-.61-1.26-.61-2.34,0-2.15.88-3.23,2.65-3.23s2.62.9,2.62,2.71l-.12,1.12h-3.53c0,.37.11.63.29.8Zm1.77-2.02c0-.48-.08-.81-.23-1s-.42-.28-.8-.28-.65.1-.8.29c-.16.2-.24.53-.25.99h2.08Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.6,3.9c-.99-.13-1.69-.19-2.08-.19s-.65.04-.77.11c-.12.07-.17.19-.17.34s.08.26.23.32c.16.06.56.15,1.2.26.64.12,1.1.31,1.37.57s.41.69.41,1.28c0,1.3-.8,1.94-2.41,1.94-.53,0-1.17-.07-1.92-.22l-.38-.07.05-1.34c.99.13,1.68.19,2.07.19s.65-.04.79-.11c.14-.08.21-.19.21-.34s-.07-.26-.22-.34c-.15-.07-.53-.16-1.15-.26s-1.08-.28-1.39-.53c-.3-.25-.46-.69-.46-1.33s.22-1.12.65-1.44.99-.49,1.67-.49c.47,0,1.12.08,1.93.23l.4.07-.02,1.33Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.26,3.9c-.99-.13-1.69-.19-2.08-.19s-.65.04-.77.11c-.12.07-.17.19-.17.34s.08.26.23.32c.16.06.56.15,1.2.26.64.12,1.1.31,1.37.57s.41.69.41,1.28c0,1.3-.8,1.94-2.41,1.94-.53,0-1.17-.07-1.92-.22l-.38-.07.05-1.34c.99.13,1.68.19,2.07.19s.65-.04.79-.11c.14-.08.21-.19.21-.34s-.07-.26-.22-.34c-.15-.07-.53-.16-1.15-.26s-1.08-.28-1.39-.53c-.3-.25-.46-.69-.46-1.33s.22-1.12.65-1.44.99-.49,1.67-.49c.47,0,1.12.08,1.93.23l.4.07-.02,1.33Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.94,3.08c.42-.55,1.13-.82,2.12-.82s1.7.27,2.12.82c.42.55.64,1.32.64,2.31,0,2.1-.92,3.16-2.76,3.16s-2.76-1.05-2.76-3.16c0-.99.21-1.76.64-2.31Zm1.24,3.67c.16.29.46.43.88.43s.72-.14.88-.43c.16-.29.25-.74.25-1.36s-.08-1.06-.25-1.34c-.16-.28-.46-.42-.88-.42s-.72.14-.88.42c-.16.28-.25.73-.25,1.34s.08,1.07.25,1.36Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.9,12.24h1.74l-1.9,8.16h-3.06l-1.9-8.16h1.74l1.42,6.72h.54l1.42-6.72Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.72,20.4v-8.16h1.66v8.16h-1.66Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.47,20.4l1.84-8.16h3.14l1.84,8.16h-1.66l-.32-1.48h-2.86l-.32,1.48h-1.66Zm3.12-6.79l-.83,3.88h2.23l-.83-3.88h-.58Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.19,20.27c-.85.18-1.61.28-2.29.28s-1.22-.08-1.63-.25c-.41-.17-.73-.44-.96-.8-.23-.37-.39-.8-.48-1.3-.09-.5-.13-1.12-.13-1.87,0-1.58.22-2.67.67-3.29.44-.62,1.26-.93,2.45-.93.69,0,1.48.11,2.39.32l-.05,1.32c-.79-.12-1.45-.18-1.97-.18s-.9.07-1.12.21c-.22.14-.39.41-.5.8-.11.39-.16,1.06-.16,2s.11,1.6.33,1.96c.22.36.66.55,1.32.55s1.36-.06,2.11-.17l.04,1.36Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.85,20.4l1.84-8.16h3.14l1.84,8.16h-1.66l-.32-1.48h-2.86l-.32,1.48h-1.66Zm3.12-6.79l-.83,3.88h2.23l-.83-3.88h-.58Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.4,20.4h-4.64v-8.16h1.66v6.7h2.99v1.46Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.17,20.4h-2.75v-8.16h2.75c.7,0,1.28.07,1.74.22s.81.39,1.06.73c.25.34.43.74.52,1.2s.14,1.06.14,1.79-.04,1.35-.13,1.83c-.09.48-.25.92-.5,1.3-.24.38-.6.66-1.06.83-.46.17-1.06.26-1.78.26Zm1.74-3.24c.02-.26.02-.61.02-1.06s-.02-.81-.05-1.09c-.03-.27-.11-.52-.23-.74s-.3-.38-.53-.46c-.24-.08-.55-.13-.95-.13h-1.09v5.28h1.09c.6,0,1.04-.15,1.31-.46.23-.25.38-.7.43-1.34Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.08,20.4v-8.16h5.28v1.44h-3.62v1.91h2.9v1.42h-2.9v1.96h3.62v1.44h-5.28Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.38,17.66v2.74h-1.66v-8.16h3.17c1.92,0,2.88.9,2.88,2.69,0,1.06-.4,1.85-1.2,2.35l1.16,3.12h-1.81l-.95-2.74h-1.6Zm2.41-1.78c.19-.24.29-.56.29-.95s-.1-.7-.31-.94-.5-.35-.88-.35h-1.51v2.59h1.54c.39,0,.68-.12.88-.36Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.39,20.4l1.84-8.16h3.14l1.84,8.16h-1.66l-.32-1.48h-2.86l-.32,1.48h-1.66Zm3.12-6.79l-.83,3.88h2.23l-.83-3.88h-.58Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473.96,20.4h-5.14v-1.4l1.69-1.72c.6-.62,1.02-1.09,1.25-1.42.24-.33.35-.68.35-1.05s-.1-.63-.29-.79c-.2-.15-.47-.23-.83-.23-.54,0-1.12.05-1.75.14l-.29.04-.08-1.28c.78-.24,1.6-.36,2.44-.36,1.68,0,2.52.76,2.52,2.27,0,.59-.13,1.1-.38,1.54-.26.43-.72.96-1.39,1.57l-1.38,1.25h3.29v1.44Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.78,12.48v7.92h-1.66v-6.05l-1.72,1.1-.76-1.24,2.62-1.74h1.51Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.04,29.53c-.39-.3-.95-.23-1.25.16l-12.77,16.62-1.03-7.84c-.06-.49-.51-.83-1-.77-.49.06-.83.51-.77,1l1.31,9.97c.06.49.51.83,1,.77,0,0,0,0,0,0l9.97-1.31c.49-.06.83-.51.77-1s-.51-.83-1-.77l-7.84,1.03,12.77-16.62c.3-.39.23-.95-.16-1.25",
    style: {
      fill: "#e20613",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.27,469.06v-1.63h1.61v1.63h-1.61Zm0,6.77v-6h1.61v6h-1.61Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.97,475.83h-1.61v-6h1.6v.34c.54-.32,1.04-.48,1.5-.48.8,0,1.35.24,1.66.71.3.47.46,1.2.46,2.18v3.25h-1.61v-3.2c0-.51-.06-.89-.18-1.13s-.36-.37-.72-.37c-.33,0-.64.06-.95.17l-.14.05v4.49Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.43,476.58c0,.68-.26,1.19-.79,1.52-.53.33-1.24.49-2.14.49s-1.59-.12-2.08-.36c-.48-.24-.73-.68-.73-1.31,0-.5.29-.98.86-1.43-.3-.2-.44-.5-.44-.91,0-.16.12-.42.36-.79l.11-.17c-.54-.39-.82-.97-.82-1.73s.23-1.32.69-1.66c.46-.34,1.07-.52,1.83-.52.34,0,.68.04,1.02.12l.19.04,1.93-.06v1.28l-.9-.07c.18.27.26.54.26.82,0,.8-.2,1.35-.61,1.66-.41.3-1.05.46-1.92.46-.18,0-.35-.02-.49-.05-.08.21-.12.38-.12.51s.07.22.2.27c.14.05.46.08.96.08,1.01,0,1.7.14,2.06.4.37.26.55.73.55,1.42Zm-4.15.17c0,.34.42.52,1.27.52s1.27-.2,1.27-.6c0-.22-.07-.35-.22-.41-.14-.06-.45-.09-.91-.1l-1.08-.08c-.22.22-.32.44-.32.68Zm.1-4.91c0,.59.31.88.92.88s.92-.29.92-.88-.31-.88-.92-.88-.92.29-.92.88Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.41,475.83v-6h1.6v.64c.67-.4,1.31-.66,1.92-.78v1.62c-.65.14-1.2.28-1.67.42l-.24.08v4.02h-1.61Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.48,474.31c.19.16.46.25.81.25.74,0,1.41-.02,1.99-.07l.34-.04.02,1.19c-.92.22-1.75.34-2.5.34-.9,0-1.56-.24-1.97-.72-.41-.48-.61-1.26-.61-2.34,0-2.15.88-3.23,2.65-3.23s2.62.9,2.62,2.71l-.12,1.12h-3.53c0,.37.11.63.29.8Zm1.77-2.02c0-.48-.08-.81-.23-1s-.42-.28-.8-.28-.65.1-.8.29c-.16.2-.24.53-.25.99h2.08Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.3,471.33c-.99-.13-1.69-.19-2.08-.19s-.65.04-.77.11c-.12.07-.17.19-.17.34s.08.26.23.32c.16.06.56.15,1.2.26.64.12,1.1.31,1.37.57s.41.69.41,1.28c0,1.3-.8,1.94-2.41,1.94-.53,0-1.17-.07-1.92-.22l-.38-.07.05-1.34c.99.13,1.68.19,2.07.19s.65-.04.79-.11c.14-.08.21-.19.21-.34s-.07-.26-.22-.34c-.15-.07-.53-.16-1.15-.26s-1.08-.28-1.39-.53c-.3-.25-.46-.69-.46-1.33s.22-1.12.65-1.44.99-.49,1.67-.49c.47,0,1.12.08,1.93.23l.4.07-.02,1.33Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.96,471.33c-.99-.13-1.69-.19-2.08-.19s-.65.04-.77.11c-.12.07-.17.19-.17.34s.08.26.23.32c.16.06.56.15,1.2.26.64.12,1.1.31,1.37.57s.41.69.41,1.28c0,1.3-.8,1.94-2.41,1.94-.53,0-1.17-.07-1.92-.22l-.38-.07.05-1.34c.99.13,1.68.19,2.07.19s.65-.04.79-.11c.14-.08.21-.19.21-.34s-.07-.26-.22-.34c-.15-.07-.53-.16-1.15-.26s-1.08-.28-1.39-.53c-.3-.25-.46-.69-.46-1.33s.22-1.12.65-1.44.99-.49,1.67-.49c.47,0,1.12.08,1.93.23l.4.07-.02,1.33Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.64,470.51c.42-.55,1.13-.82,2.12-.82s1.7.27,2.12.82c.42.55.64,1.32.64,2.31,0,2.1-.92,3.16-2.76,3.16s-2.76-1.05-2.76-3.16c0-.99.21-1.76.64-2.31Zm1.24,3.67c.16.29.46.43.88.43s.72-.14.88-.43c.16-.29.25-.74.25-1.36s-.08-1.06-.25-1.34c-.16-.28-.46-.42-.88-.42s-.72.14-.88.42c-.16.28-.25.73-.25,1.34s.08,1.07.25,1.36Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.92,479.67h1.74l-1.9,8.16h-3.06l-1.9-8.16h1.74l1.42,6.72h.54l1.42-6.72Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.74,487.83v-8.16h1.66v8.16h-1.66Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.48,487.83l1.84-8.16h3.14l1.84,8.16h-1.66l-.32-1.48h-2.86l-.32,1.48h-1.66Zm3.12-6.79l-.83,3.88h2.23l-.83-3.88h-.58Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.03,485.46h-1.34v2.38h-1.66v-8.16h3c1.94,0,2.9.94,2.9,2.83,0,.95-.25,1.68-.74,2.19-.49.51-1.21.76-2.17.76Zm-1.34-1.42h1.33c.82,0,1.24-.51,1.24-1.54,0-.5-.1-.87-.3-1.09-.2-.22-.51-.33-.94-.33h-1.33v2.95Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.76,485.1v2.74h-1.66v-8.16h3.17c1.92,0,2.88.9,2.88,2.69,0,1.06-.4,1.85-1.2,2.35l1.16,3.12h-1.81l-.95-2.74h-1.6Zm2.41-1.78c.19-.24.29-.56.29-.95s-.1-.7-.31-.94-.5-.35-.88-.35h-1.51v2.59h1.54c.39,0,.68-.12.88-.36Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.54,487.83v-8.16h1.66v8.16h-1.66Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.39,479.67h1.74l-1.9,8.16h-3.06l-1.9-8.16h1.74l1.42,6.72h.54l1.42-6.72Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.2,487.83l1.84-8.16h3.14l1.84,8.16h-1.66l-.32-1.48h-2.86l-.32,1.48h-1.66Zm3.12-6.79l-.83,3.88h2.23l-.83-3.88h-.58Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.93,481.14v-1.46h6v1.46h-2.16v6.7h-1.66v-6.7h-2.18Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.85,487.83l1.84-8.16h3.14l1.84,8.16h-1.66l-.32-1.48h-2.86l-.32,1.48h-1.66Zm3.12-6.79l-.83,3.88h2.23l-.83-3.88h-.58Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.04,487.83h-4.64v-8.16h1.66v6.7h2.99v1.46Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.84,487.83v-1.99h1.73v1.99h-1.73Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.38,481.11v-1.44h5.4v1.44l-3.41,5.06v.22h3.41v1.44h-5.4v-1.43l3.41-5.08v-.22h-3.41Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.8,486.96c-.51.68-1.38,1.01-2.62,1.01s-2.11-.34-2.62-1.01c-.51-.68-.76-1.73-.76-3.17s.25-2.51.76-3.21c.51-.7,1.38-1.05,2.62-1.05s2.11.35,2.62,1.05c.51.7.76,1.77.76,3.21s-.25,2.5-.76,3.17Zm-3.95-1.06c.24.42.68.63,1.33.63s1.09-.21,1.33-.63c.24-.42.35-1.12.35-2.11s-.12-1.71-.36-2.15c-.24-.45-.68-.67-1.32-.67s-1.08.22-1.32.67c-.24.45-.36,1.17-.36,2.15s.12,1.69.35,2.11Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.25,488.67v-1.44c.32,0,.55-.06.7-.18.14-.12.22-.34.22-.67v-6.71h1.64v6.78c.01.87-.18,1.46-.57,1.76-.39.3-1.05.46-1.99.46Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.85,487.83l1.84-8.16h3.14l1.84,8.16h-1.66l-.32-1.48h-2.86l-.32,1.48h-1.66Zm3.12-6.79l-.83,3.88h2.23l-.83-3.88h-.58Z",
    style: {
      fill: "#e20613",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.6,464.18c.49.06.93-.28.99-.77l2.62-20.8,4.85,6.25c.3.39.86.46,1.25.16.39-.3.46-.86.16-1.25l-6.17-7.94c-.3-.39-.86-.46-1.25-.16,0,0,0,0,0,0l-7.94,6.17c-.39.3-.46.86-.16,1.25s.86.46,1.25.16l6.25-4.85-2.62,20.8c-.06.49.28.93.77.99",
    style: {
      fill: "#e20613",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(40.73 266.67) rotate(36.63)",
    style: {
      fill: "#fff",
      fontFamily: "TitilliumWeb-Bold, &apos",
      fontSize: 12,
      fontWeight: 700
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.44,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "OM"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.56,
    y: 0,
    style: {
      letterSpacing: "-.02em"
    }
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.4,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "A"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 38.54,
    y: 0
  }, "SS ")), /*#__PURE__*/React.createElement("tspan", {
    x: 54.24,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "B"), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 61.45,
    y: 0
  }, "ANCA"))), /*#__PURE__*/React.createElement("path", {
    d: "m394.51,342.31c.76,2.32,2.49,8.22,2.49,15.07,0,27.34-22.16,49.5-49.5,49.5s-49.5-22.16-49.5-49.5,22.16-49.5,49.5-49.5c10.83,0,19.04,3.64,21.91,5.1",
    style: {
      fill: "none",
      stroke: "#e20613",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(347.95 332.14)",
    style: {
      fill: "#e20613",
      fontFamily: "TitilliumWeb-Bold, &apos",
      fontSize: 14,
      fontWeight: 700
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MAP")), /*#__PURE__*/React.createElement("tspan", {
    x: 28.69,
    y: 0,
    style: {
      letterSpacing: "-.02em"
    }
  }, "P"), _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 36.67,
    y: 0
  }, "A 2 e 3"))), /*#__PURE__*/React.createElement("path", {
    d: "m424.5,459.39c-6.02.06-10.52-1.25-11.63-1.59-15.51-4.75-31.42-20.72-31.37-41.41.06-22.28,18.63-43,43-43s43,19.25,43,43c0,10.88-4.3,19.05-5.89,21.74",
    style: {
      fill: "none",
      stroke: "#e20613",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(428.52 453.14)",
    style: {
      fill: "#e20613",
      fontFamily: "TitilliumWeb-Bold, &apos",
      fontSize: 14,
      fontWeight: 700
    }
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MAP")), /*#__PURE__*/React.createElement("tspan", {
    x: 28.69,
    y: 0,
    style: {
      letterSpacing: "-.02em"
    }
  }, "P"), _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 36.67,
    y: 0
  }, "A 6"))), /*#__PURE__*/React.createElement("path", {
    d: "m287.35,16.38c3.47-1.92,11.42-5.69,20.65-5.5,18.35.38,43,16.47,43,43,0,23.75-19.25,43-43,43s-43-19.25-43-43c0-8.64,2.64-15.22,3.77-17.62",
    style: {
      fill: "none",
      stroke: "#e20613",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(248.52 31.14)",
    style: {
      fill: "#e20613",
      fontFamily: "TitilliumWeb-Bold, &apos",
      fontSize: 14,
      fontWeight: 700
    }
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MAP")), /*#__PURE__*/React.createElement("tspan", {
    x: 28.69,
    y: 0,
    style: {
      letterSpacing: "-.02em"
    }
  }, "P"), _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 36.67,
    y: 0
  }, "A 4"))), /*#__PURE__*/React.createElement("path", {
    d: "m184.64,374.83s-1.9-6.86-1.64-13.45c.89-22.79,20.72-55.5,55.5-55.5,30.65,0,55.5,24.85,55.5,55.5s-24.85,55.5-55.5,55.5c-17.9,0-31.63-10.44-35.43-13.64",
    style: {
      fill: "none",
      stroke: "#e20613",
      strokeMiterlimit: 10,
      strokeWidth: "2.24px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(165.52 395.14)",
    style: {
      fill: "#e20613",
      fontFamily: "TitilliumWeb-Bold, &apos",
      fontSize: 14,
      fontWeight: 700
    }
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MAP")), /*#__PURE__*/React.createElement("tspan", {
    x: 28.69,
    y: 0,
    style: {
      letterSpacing: "-.02em"
    }
  }, "P"), _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 36.67,
    y: 0
  }, "A 5"))), /*#__PURE__*/React.createElement("path", {
    d: "m73.14,113.1c1.94-1.81,26.31-24.11,59.36-23.21,40.59,1.1,87.5,35.19,87.5,87.5,0,48.32-39.18,87.5-87.5,87.5s-87.5-39.18-87.5-87.5c0-14.23,5.26-28.9,5.26-28.9",
    style: {
      fill: "none",
      stroke: "#e20613",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(34.31 135)",
    style: {
      fill: "#e20613",
      fontFamily: "TitilliumWeb-Bold, &apos",
      fontSize: 14,
      fontWeight: 700
    }
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MAP")), /*#__PURE__*/React.createElement("tspan", {
    x: 28.69,
    y: 0,
    style: {
      letterSpacing: "-.02em"
    }
  }, "P"), _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 36.67,
    y: 0
  }, "A 1")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappaGenerale);
export default __webpack_public_path__ + "static/media/mappa-generale.e7e5a7bf91a00d7711fb0367631b56d2.svg";
export { ForwardRef as ReactComponent };